import React from 'react';

import DropDownButton from 'devextreme-react/drop-down-button';

import DataModelView from '../../common/view/DataModelView';

import { DateViewMode } from '../../common/value-types/DateViewMode';

import DayRolloverAlert from '../../media/DayRolloverAlert.png';

const viewModeItems = [
  { id: DateViewMode.fullMonth, text: 'Full Month View' },
  { id: DateViewMode.weccPreschedule, text: 'WECC: Preschedule' },
  { id: DateViewMode.weccRealtime, text: 'WECC: Realtime' }
];

export default class ScheduleDateContextView extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'dateViewMode',
      'showDateRolloverWarning'
    ];
  }

  render() {
    return (
      <div className="pwx-datebox-header">
        <DropDownButton
          displayExpr="text"
          dropDownOptions={{
            width: 150,
            wrapperAttr: {
              class: 'pwx-datebox-header-dropdown'
            }
          }}
          keyExpr="id"
          items={viewModeItems}
          onSelectionChanged={this.onSelectedModeChanged.bind(this)}
          selectedItemKey={this.state.dateViewMode}
          useSelectMode={true}
        />
        <img
          className="pwx-rollover-warning"
          src={DayRolloverAlert}
          alt="Rollover Warning"
          hidden={!this.state.showDateRolloverWarning}
          title="The current date is about to rollover."
        />
      </div>
    );
  }

  onSelectedModeChanged(event) {
    this.dataModel.updateProperties({
      dateViewMode: event.item.id
    });

    this.dataModel.gridFiltersChanged();
  }
}